export const getFormatsFromFormatParam = (format: string) => {
  // for storyblok preview:
  if (format === 'conversion-template')
    return {
      from: 'nef',
      to: 'jpg',
    };

  if (format === 'format-template')
    return {
      from: 'nef',
    };

  return {
    from: format.split('-')[0],
    to: format.split('-')[2],
  };
};
